<div class="reLogin d-flex justify-content-center align-items-center">
    <div class="reLogin__wrapper p-5 d-flex flex-column">
         <p class="reLogin__warning">{{labels.message.stillThere}}</p> 
         <p class="mb-5">{{labels.message.sessionOut}} <span class="reLogin__counter">{{countDown}}</span> seconds</p>
        <div class="d-flex justify-content-end">
            <button type="button" id="reLoginTest1" class="btn btn-primary" (click)="validate()">{{labels.message.iAmHere}}</button>
        </div>
    </div>
</div>